import http from '@/services/http';

export interface ClientBalanceVaribox {
  varibox_id: string;
  serial_number: string;
  radex_identifier: string;
  status: string;
  location: string;
  since: string | null;
  days_at_client: number | null;
}

export interface ClientBalanceReport {
  scope_id: string;
  scope_name: string;
  scope_type: 'client' | 'location';
  company_name: string | null;
  address_line: string | null;
  postal_code: string | null;
  city: string | null;
  city_code: string | null;
  generated_at: string;
  current_stock_count: number;
  recorded_client_days: number;
  variboxes_without_start_date: number;
  variboxes: ClientBalanceVaribox[];
}

export async function getClientBalance(clientId: string) {
  const response = await http.get<ClientBalanceReport>(`/api/clients/${clientId}/balance`);
  return response.data;
}

export async function getLocationBalance(locationId: string) {
  const response = await http.get<ClientBalanceReport>(`/api/locations/${locationId}/balance`);
  return response.data;
}
